import { cn } from '@lair-finance/util'
import { AssetIcon } from '@/shared/ui/Asset'
import { Tooltip } from '@/shared/ui/Tooltip'
import { MenuLink } from '@/domains/header/components/Header/AppMenu/MenuItem.tsx'
import { AppMenuList, Menu } from '@/domains/header/config'
import { useLocation } from 'react-router-dom'
import { useMemo, useState } from 'react'
import { Logo } from '@/domains/header/components/Header/Logo.tsx'
import { useChainId } from '@lair-finance/wagmi'

export function AppMenu({ className }: { className?: string }) {
  const [open, setOpen] = useState(false)
  const chainId = useChainId()
  const menuList = useMemo(() => AppMenuList[chainId], [chainId])

  if (menuList.length <= 0) {
    return <Logo />
  }

  return (
    <Tooltip
      open={open}
      onOpenChange={setOpen}
      className={'w-[160px] bg-greyscale-700 p-[7px] border border-greyscale-500 rounded-[8px]'}
      align={'start'}
      sideOffset={8}
      trigger={
        <div className={cn('inline-flex-center gap-x-2', className)}>
          <Logo />
          <AssetIcon filename={open ? 'toggle-on.png' : 'toggle.png'} size={12} />
        </div>
      }
      content={<AppMenuContent data={menuList} />}
      noStyle
    />
  )
}

function AppMenuContent({ data }: { data: Menu[] }) {
  const location = useLocation()

  return (
    <div className={'flex flex-col gap-y-1'}>
      {data.map(item => (
        <MenuLink key={item.id} to={item.path} active={item.isActive(location.pathname)}>
          {item.name}
          {item.isNew && (
            <span className={'ml-2 inline-flex-center px-1 h-4 rounded-[4px] bg-primary-500 text-greyscale-100 typo-new-label-3'}>New</span>
          )}
        </MenuLink>
      ))}
    </div>
  )
}
